/* C11 · qt-polaroids.js — browse the stack by changing data-plek order only (rotation stays in CSS).
   Editor: selecting a polaroid brings it to the front. Parallax via --qt-parallax-polaroid on the stack
   (not on the photos), none under reduced motion. Spec: 01-componenten.md C11. */
import { register, onScroll, prefersReducedMotion } from '@qt/core';

const state = new WeakMap();

function order(root, front) {
  const s = state.get(root);
  s.front = (front + s.items.length) % s.items.length;
  s.items.forEach((item, i) => {
    item.dataset.plek = String(Math.min(2, (i - s.front + s.items.length) % s.items.length));
  });
}

register('[data-qt-polaroids]', {
  init(root) {
    const stack = root.querySelector('.qt-polaroids__stack');
    const items = [...stack.children];
    const s = { items, front: 0, cleanups: [] };
    state.set(root, s);
    order(root, 0);
    const onClick = (event) => {
      const step = event.target.closest('[data-polaroid-step]');
      if (step) order(root, s.front + Number(step.dataset.polaroidStep));
    };
    root.addEventListener('click', onClick);
    s.cleanups.push(() => root.removeEventListener('click', onClick));
    const strength = parseFloat(getComputedStyle(root).getPropertyValue('--qt-parallax-polaroid')) || 0;
    if (strength > 0 && !prefersReducedMotion()) {
      s.cleanups.push(onScroll(() => {
        const r = root.getBoundingClientRect();
        const offset = window.innerHeight / 2 - (r.top + r.height / 2); // concept: distance of the stack's centre to mid-screen
        stack.style.translate = `0 ${Math.round(offset * strength)}px`;
      }));
    }
  },
  destroy(root) {
    state.get(root)?.cleanups.forEach((cleanup) => cleanup());
    state.delete(root);
  },
  select(root, block) {
    const s = state.get(root);
    const index = s ? s.items.findIndex((item) => item.contains(block) || item === block) : -1;
    if (index >= 0) order(root, index);
  },
});
